import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['track', 'slide'];

  connect() {
    this.currentIndex = 0;
    this.gap = 24; // 24px = tw-gap-6
    this.updateCarousel();
    this.startAutoPlay();
  }

  disconnect() {
    this.stopAutoPlay();
  }

  next() {
    this.stopAutoPlay();
    this.currentIndex = (this.currentIndex + 1) % this.slideTargets.length;
    this.updateCarousel();
    this.startAutoPlay();
  }

  prev() {
    this.stopAutoPlay();
    this.currentIndex =
      (this.currentIndex - 1 + this.slideTargets.length) % this.slideTargets.length;
    this.updateCarousel();
    this.startAutoPlay();
  }

  updateCarousel() {
    if (!this.hasSlideTarget) return;

    // Calculate the slide width including gap
    const slideWidth = this.slideTargets[0].offsetWidth;
    const offset = -(this.currentIndex * (slideWidth + this.gap));

    this.trackTarget.style.transform = `translateX(${offset}px)`;
  }

  startAutoPlay() {
    this.stopAutoPlay();
    this.autoPlayInterval = setInterval(() => {
      this.next();
    }, 5000);
  }

  stopAutoPlay() {
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
    }
  }
}
